export default __webpack_public_path__ + "static/media/postgresql.517902bf.svg";